import templateStr from 'text!./tile.html';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            tileTitle: '@',
            tileValue: '@',
            tileIcon: '@',
            tileHeaderColor: '@'
        },
        replace: true
    };
}];
